export default __webpack_public_path__ + "static/fangting1-97ce28111c606dce9925b6a9327f1a10.jpg";